export default {
    sysTitle: "商户平台",
    operatorId: "运营商代码",
    oprName: "运营商名称",
    tips: "提示",
    isDelete: "是否确认删除",
    deleteSuccess: "删除成功",
    updateSuccess: "修改成功",
    addSuccess: "新增成功",
    all: "全部",
    operation: "操作",
    dl: "电量",
    eleFee: "电费",
    serverFee: "服务费",
    delayFee: "占桩费",
    totalAmount: "总金额",
    yuan: "元",
    kWh: "度",
    unitOrder: "单",
    ac: "交流",
    dc: "直流",
    confirm: "确认",
    noData: "暂无数据",
    allCity: "全部城市",
    chargingStation: "充电站",
    merchant: "商户",
    operator: "运营商",
    chargingPile: "充电桩",
    year: "年",
    month: "月",
    day: "日",
    yesterday: "昨日",
    today: "今日",
    thisMonth: "本月",
    thisYear: "本年",
    allday: "累计",
    timeType: "类型",
    regularText: "正常",
    irregular: "异常",
    operationSucess: "操作成功",
    saveSucess: "保存成功",
    exportSuccess: "导入成功",
    allSelect: "全选",
    toExamine: "审核",
    invalid: "作废",
    check: "审核",
    invoicing: "开票",
    agree: "同意",
    refuse: "拒绝",
    multipleChoice: "表头设置",
    exportEdit: "导出编辑",
    edit: "编辑",
    loading: "加载中...",
    outText: "登录过期，请重新登录",
    browse: "浏览",
    //单位
    unitText: {
        pen: "笔",
        yuan: "元",
        hours: "时",
        people: "人",
        seat: "座",
        wan: "万",
        wyuan: "万元",
        wkWh: "万kWh",
        wkW: "万kW",
        year: "年",
        month: "月",
        day: "日",
        ton: "吨",
        second: "次",
        full: "满",
        reduce: "减",
        give: "送",
        zhang: "张",
        individual: "个",
        xHours: "小时",
        minute: "分钟",
        seconds: "秒",
        noDiscount: "无折扣",
        hold: "把",
        set: "台",
        total: "总",
        days: "天",
    },
    // form 里公用组件或者公用文字的
    formText: {
        startTime: "开始时间",
        endTime: "结束时间",
        export: "导出",
        exportLoading: "导出中...",
        exportNumber: "导出条数",
        exportPl: "导出条数不能少于等于0",
        exportError: "导出出错或者超时",
        allCity: "全部城市",
        selectGun: "充电枪",
        selectMch: "商户",
        selectSite: "充电站",
        selectPile: "充电桩",
        selectTime: "选择时间",
        selectTimePl: "请选择时间",
        selectOper: "运营商",
        downloadForm: "下载表格",
        intTips: "数值",
        beginTimeTips: "请选择开始时间",
        endTimeTips: "请选择结束时间",
        import: "导入",
        selectProvince: "请选择省",
        selectCity: "请选择市",
        selectArea: "请选择区",
        subSuccess: "操作成功",
        goBack: "返回",
        timeNull: "请选择时间",
        timeMax: "开始时间不能超过结束时间",
    },
    // 验证
    regular: {
        name: "名称",
        please: "请输入",
        max: "不能超过",
        maxText: "个字符",
        min: "不能少于",
        numberABC: "只能由数字或者字母组成",
        numberABCs: "只能由数字+字母+下划线组成",
        tel: "请输入手机号码或者座机号码，7-15位",
        phone: "请输入电话",
        phonePl: "请输入手机号码",
        phonePl11: "请输入11位数字的手机号码",
        phoneError: "请输入正确格式的手机号码",
        int: "只能是整数数字",
        maxInput: "最多输入",
        minInput: "最少输入",
        unit: "位",
        maxNum: "不能大于",
        minNum: "不能小于",
        money: "金额",
        towDecimal: "最多保留两位小数",
        email: "请输入邮箱",
        emailPl: "邮箱不能超过",
        emailError: "请填写正确的邮箱",
        passwordPl: "请输入密码",
        passwordError: "密码必须包含字母和数字且长度在8-16之间，请重新输入",
    },
    directCurrent: "直流",
    alternatingCurrent: "交流",
    gunStatus: "枪口状态",
    gunStatusObj: {
        onLine: "在线",
        offLine: "离线",
        free: "空闲",
        connected: "插枪",
        charging: "充电",
        full: "充满",
        trouble: "故障",
        disabled: "禁用",
        booked: "预约",
    },
    //===========================按钮===========================
    search: "查询",
    update: "修改",
    add: "新增",
    delete: "删除",
    close: "关闭",
    save: "保存",
    refresh: "刷新",
    back: "返回",
    export: "导出",
    import: "导入",
    submit: "提交",
    cancel: "取消",
    details: "详情",
    determine: "确定",
    //===========================云产品===========================
    // 登录
    login: {
        contentTitle: "为美好生活充电",
        contentTitleSmall: "接入开放平台，互联生态一目了然",
        account: "账号登录",
        userNamePl: "请输入用户名",
        passwordPl: "请输入密码",
        passwordMax: "请输入6位以上的密码",
        userName: "用户名",
        password: "密码",
        login: "登录",
        accountTime: "账号将在",
        accountTime2: "天后失效，失效后将无法登录系统",
        mchSys: "商户系统",
        changeLangPl: "请选择语言",
    },
    home: {
        assetTitle: "资产信息",
        staCount: "充电站统计(个)",
        pileCount: "充电桩统计(个)",
        gunCount: "充电枪口统计(个)",
        totalPower: "总功率统计(kW)",
        chargeEcharTitle: "充电及收入",
        chargeEcharTypeDay: "(近30天，不含今天)",
        chargeEcharTypeMonth: "(近12月)",
        chargeEcharTypeYear: "(近10年)",
        feeYAxisName: "费用",
        map: "充电地图",
        gunTotal: "枪总数",
        dataStatistics: "充电数据统计",
        chargeDl: "充电量(kW·h)",
        totalTransAmount: "充电金额(元)",
        chargeTimes: "充电次数(次)",
        useRate: "使用率",
        mchIncomeAmount: "收益金额(元)",
        avgChargeTimes: "平均充电次数",
        monthAvgUseRate: "本月站点使用率",
        totalIncomeAmount: "收入金额",
        mchPayAmount: "支出金额",
        gunStatus: "充电枪状态",
        rankingTitle: "站点排名",
        rankingTitleDl: "充电量",
        rankingTitleMoney: "金额",
        rankingNo: "暂无排行",
        mapStaStutas: "充电站状态",
        mapAc: "交流桩",
        mapDc: "直流桩",
        mapQuery: "查看",
        mapStaTel: "站点电话",
        todayOrder: "今日订单量(单)",
        todayDl: "今日充电量(度)",
        todayRevenue: "今日营收(元)",
        yesterdayOrder: "昨日订单趋势",
        todayDlTime: "今日00:00-24:00充电电量(度)",
        todayOrderTime: "今日00:00-24:00创建的订单量(单)",
        siteNum: "站点统计",
        pileNum: "电桩统计",
        gunNum: "枪口统计",
        dcNum: "直流口",
        acNum: "交流口",
        dcPower: "直流桩功率",
        acPower: "交流桩功率",
        settlementTitle: "结算信息",
        dailyDtatement: "未结算日结单",
        withdrawalForm: "未付款提现单",
        undrawnAmount: "正在付款金额",
        withdrawnAmount: "已付款金额",
        revenueTitle: "营收统计",
        totalRevenue: "收入金额总计(元)",
        onlineChargingSharing: "线上充电分成(元)",
        offlineChargingSharing: "线下充电分成(元)",
        yesterdayRanking: "昨日设备利用率TOP",
        pile: "电桩",
        utilizationRate: "利用率",
        order: "订单(笔)",
        total: "总数",
        hour: "时",
    },
    // 主页地图
    homeMap: {
        search: "搜索",
        reset: "重置",
        area: "区域",
        power: "功率",
        quantity: "数量",
        tower: "台",
        merchant: "商户",
        deviceType: "设备类型",
        staSize: "电站规模",
        netDirection: "互联互通",
        staStatus: "运营状态",
        staActivity: "站点活动",
        normalSearch: "普通搜索",
        advancedSearch: "高级搜索",
        ac: "交流桩",
        dc: "直流桩",
        smallSize: "小规模",
        mediumSize: "中规模",
        largeSize: "大规模",
        yes: "是",
        no: "否",
        site: "站点",
        pile: "电桩",
        screenPl: "请输入充电站、运营商名称",
        screenResult: "为您找到相关结果",
        moreSelect: "多选",
        more: "更多",
        notOpened: "未开通",
    },
    //非实名卡管理
    nonCard: {
        cardMember: "电卡会员(人)",
        cardMemberStatis: "电卡会员状态",
        use: "使用中电卡(张)",
        logOff: "已注销电卡(张)",
        recharged: "今年已充值(元)",
        charged: "今年已充电(元)",
        globalSearch: "流水号/电卡序号/联系人/联系电话",
        cardStatis: "电卡状态",
        activation: "激活",
        normal: "正常",
        logOffBtn: "注销",
        rechargedBtn: "充值",
        refundBtn: "退款",
        operationRecord: "操作记录",
        capitalRecord: "资金记录",
        thisYear: "今年",
        accountPkId: "电卡会员号",
        cardPhysicalNumber: "电卡序号",
        cardSerialNumber: "流水号",
        silkScreenNumber: "丝印编号",
        contactName: "联系人",
        phoneNo: "联系电话",
        accountBalance: "卡内余额",
        cardStatus: "电卡状态",
        createTime: "开卡时间",
        cardPkId: "卡号",
        remarks: "备注",
        rechargeAmount: "充值金额",
    },
    nonFundHistory: {
        rechargedTab: "充值",
        chargedTab: "充电",
        refundTab: "退款",
        staName: "站点名称",
        chargeBeginTime: "开始时间",
        chargeEndTime: "结束时间",
        chargeMinutes: "充电时长",
        chargeElect: "充电量(kWh)",
        delayAmount: "占桩费(元)",
        delayDuration: "占桩时长",
        chargeAmount: "充电费用(元)",
        beforeBalance: "交易前余额(元)",
        afterBalance: "交易后余额(元)",
        orderNo: "订单号",
        transactionTime: "充值时间",
        rechargeAmount: "金额(元)",
        createName: "操作人",
        refundTime: "申请退款时间",
        refundAmount: "申请退款金额",
        refundedAmount: "成功退款金额(元)",
        refundResultDesc: "退款进度",
        time: "时间",
    },
    // 注销卡
    cancellation: {
        cardSerialNumber: "流水号",
        accountBalance: "金额",
        tips: "注销后卡内金额将自动全额退款，充电卡将无法使用",
        success: "注销成功",
        successConfirm: "确定要注销吗?",
    },
    // 卡详情
    nonCardDetails: {
        cardInfo: "电卡信息",
        remark: "备注",
        accountBalance: "账户余额",
        createUserName: "开卡人",
        createTime: "开卡时间",
        statusDesc: "电卡状态",
    },
    nonRealNameCardManagement: {
        cardMember: "电卡会员(人)",
        cardStatus: "电卡状态",
        inUse: "使用中",
        cancelled: "已注销",
        operationStatistics: "归属统计",
        selfSupport: "运营商自营",
        generationCamp: "代营商户",
        fuzzySearch: "流水号/电卡会员号/联系人/联系电话",
        cardAffiliation: "卡片归属",
        commercialTenant: "商户",
        cardNumber: "电卡会员号",
        cardPhysicalNumber: "电卡序号",
        cardSerialNumber: "流水号",
        contacts: "联系人",
        phone: "联系电话",
        cardBalance: "卡内余额(元)",
        frozenAmount: "冻结金额(元)",
        openTime: "开卡时间",
        remark: "备注",
        money: "开卡金额",
        openCardTips: "请保持发卡器与电脑正常连接，并将卡片放置于发卡器上",
        openCardError: "该充电卡已被使用！请更换卡片",
        cardPhysicalNumberPl: "请输入电卡序号",
        cardSerialNumberPl: "请输入流水号",
        moneyPl: "请输入充值金额",
        moneyMax: "一次性充值金额不能多于5000",
        moneyMin: "一次性充值金额不能少于0",
        moneyError: "开卡金额必须数字且小数位不超过两位",
        openCardSuccess: "开卡成功",
        balance: "余额",
        amount: "金额",
        cancellation: "注销",
        cancellationTips: "注销后卡内金额将自动全额退款，充电卡将无法使用",
        cancellationSuccess: "注销成功",
        accountBalance: "账户余额(元)",
        createUserName: "开卡人",
        createTime: "开卡时间",
        status: "电卡状态",
        operationInfo: "操作信息",
        cardInfo: "电卡信息",
        cardDetails: "非实名卡详情",
        remarkPl: "请输入备注",
        createName: "操作人",
        operateTime: "操作时间",
        operateType: "操作",
        rechargeAmount: "充值金额(元)：",
        allMoneyMax: "在线卡最大金额不能超过9999元",
        accountPkId: "会员卡号",
        refundAmount: "退款金额(元)",
        refundBtn: "退款",
        refundError: "退款金额不能超过账户余额",
        refundSuccess: "退款成功",
        silkScreenNumber: "丝印编号",
        getCard: "读卡",
        input: "直接录入",
        reset: "重置",
        cardExist: "卡已存在，请先注销或者换一张卡再执行开卡操作",
        openCard: "开卡",
        silkScreenNumberPl: "请输入丝印编号",
        contactsPl: "请输入联系人",
        cardYes: "此卡可以操作",
        logout: "销卡",
        viewNo: "您的浏览器不支持发卡系统",
        connectError: "发卡器连接失败",
        logoutSuccess: "销卡成功",
        cardChange: "卡片已更换，请重新读卡",
        cardWhite: "此卡是空白卡，请先开卡",
        statusError1: "请先读卡再操作",
        statusError2: "未检测到充电卡,请重新操作",
        statusError3: "客户编码不能为空",
        statusError4: "卡类型不能为空",
        statusError5: "ID不能为空",
        statusError6: "卡Id只能是16位数字",
        statusError7: "非本系统卡，无法操作！",
        logoutTitle: "此操作销毁此卡的所有信息,请谨慎操作",
        connectBtn: "连接发卡器",
        connectBtnLoading: "正在连接发卡器……",
        cardBind: "些卡已使用，请换一张未使用过的卡片,流水号: ",
        relation: "关联",
        userName: "会员名称",
        cardNumberPl: "请输入卡号",
        relationSuccess: "关联成功",
        hasSms: "是否发送短信",
        hasSmsPl: "请选择是否发送短信",
        word: "温馨提示：操作使用说明文档",
        wordDownload: "点击此处下载",
        no: "否",
        yes: "是",
        cardConnectionFailed: "发卡器连接失败",
        notSupport: "您的浏览器不支持发卡系统",
    },
    // 发卡下载提示
    cardTips: {
        t1: "1.下载并安装发卡器驱动",
        download: "点击此处下载",
        t1_1: "XP系统请",
        t2: "2.将读卡器通过USB线连接计算机，正常上电后读卡器会'哔'一声并保持读卡器内部LED灯闪。",
        t3: "3.下载并运行发卡器插件",
        t3_1: "，连接读卡器之后点击'开启服务'即可。",
        t4: "4.打开浏览器的发卡管理进行相关操作。",
        tips: "注意事项：",
        tips1: "1.目前支持Windows操作系统，Windows 7/10各系列版本。",
        tips1_1: "如要在Windows XP下使用需要安装.net3.5框架",
        tips2: "2.运行过程中必须确保发卡器插件持续开启服务状态。",
        tips3: " 3.提示“检查是否插入读卡器或是否安装串口驱动”时，一般是没有插上读卡器或者串口驱动未安装的问题，右键“我的电脑” 选择 “管理” ，再弹出的 “计算机管理” 窗口中，点击左边菜单的“设备管理器” 后，查看 “其它设备” 下是否存在 “USB Serial Port” 或 “FT232RUSR UART”。如果没有，说明读卡器没插上，换个USB口试一试；",
    },
    // 商户信息
    addMerchant: {
        info: "基本信息",
        fullName: "商户名称",
        shortName: "商户简称",
        contacts: "联系人",
        contactsMail: "联系邮箱",
        telephone: "联系电话",
        address: "联系地址",
        operatorShare: "运营商分成",
        shareType: "分成类型",
        isMoneyRules: "固定金额",
        isMoneyRulesShareMaxError: "固定金额分成不能大于总金额，请检查",
        orderTotalMoney: "单笔订单总金额",
        orderTotalMoneyMax: "元以上",
        orderShare: "每笔订单分成",
        isMoneyRulesTips: "根据分成类型显示对应分成金额配置，多选。注：选择固定金额后，百分比类型每笔订单不能再次选择总金额",
        isPercentageRules: "百分比",
        order: "每笔订单",
        cashConfig: "提现配置",
        cashMin: "最低提现金额",
        condition: "条件",
        fromValueTips: "结算金额满",
        feeTips: "扣除转账手续费",
        feeTipsPl: "扣除转账手续费百分比",
        loginUrl: "登录地址",
        addTitle: "新增账号",
        resetPassword: "重置密码",
        mchCollectionInfo: "商户收款信息",
        bankAccountName: "银行账户名称",
        bankDeposit: "收款账户开户银行",
        bankAccountNo: "收款银行账户",
        addMch: "新增商户",
        loginTitle: "新增登录账号",
        updataTitle: "修改登录账号",
        required: "必填项",
        textLenMax: "长度不能超过",
        divisionPercentPl: "请选择分成方式",
        divisionPercentMax: "值区间：0.00~100",
        divisionPercentError: "请输入有效数字",
        base2: "百分比",
        minWithdrawAmount: "最低提现金额",
        bankDepositPl: "请输入收款账户开户银行",
        bankAccountNamePl: "请输入收款账户名称",
        userName: "登录用户名",
        effectiveTime: "生效时间",
        expireTime: "过期时间",
        accountName: "账户名称",
        bankInstitutionDesc: "银行机构",
        remarks: "备注",
        delConfig: "确定要删除当前账号吗",
        userParamsNull: "登录用户账户不能为空",
        isPercentageRulesPl: "请选择百分比分成的类型",
        isPercentageRulesError: "百分比分成的类型不能重复",
        addSuccess: "新增成功",
        mchLoginInfo: "商户登录信息",
        userParamsMax: "只能存在一个登录用户，请删除多余的",
        mchDetails: "商户详情",
        upDetails: "修改商户",
        add: "添加",
        rolePkIdPl: "请选择角色",
        expireTimePl: "请先选择生效日期",
        expireTimeError: "不能低于生效日期",
        userNameError: "用户名重复",
        issueCardCode: "客户编码",
        userPwd: "密码",
        confirmPassword: "确认密码",
        amountType: "每笔订单电费",
        amountType2: "每笔订单服务费",
        amountType3: "每笔订单占桩费",
        cooperationTime: "合作截止日期",
        fixedShare: "固定分成",
        fixedShareText: "每度电分成",
        invoiceSet: "发票设置信息",
        invoiceType: "发票类型",
        hasOpenAudit: "是否开启发票审核",
        open: "开启",
        close: "关闭",
        wxMerchantName: "微信收账商户名称",
        wxMerchantAccount: "微信收账商户账号",
        settlementType: "分成规则类型",
        onLine: "线上",
        offline: "线下",
    },
    // 修改操作密码
    upSafePassword: {
        userPwd: "新密码",
        confirmPassword: "重复新密码",
        verCode: "手机验证码",
        verCodePl: "验证码不能为空",
        userPwdPl: "密码不能为空",
        userPwdLen: "密码长度6~18",
        userPwdError: "密码不能包含空格、制表符、换行符",
        confirmPasswordPl: "确认密码不能为空",
        confirmPasswordError: "请确认新旧密码是否一致",
        upError: "修改失败",
        upSuccess: "修改密码成功,请重新登录",
    },
    // 共用名称（订单列表也在里面）
    commonTableName: {
        insideOrderNo: "内部订单号",
        externalOrderNo: "外部订单号",
        orderStatus: "订单状态",
        orderType: "订单类型",
        no: "否",
        yes: "是",
        details: "详情",
        endOrder: "结束订单",
        error: "异常处理",
        orderNo: "订单号",
        merchantName: "商户名称",
        netSystemName: "互联运营商",
        orderStatusDesc: "订单状态",
        staName: "站点名称",
        pileName: "桩名称",
        gunName: "枪名称",
        serialNumber: "桩编号",
        memberName: "会员名",
        phoneNo: "手机号",
        carNo: "车牌号",
        chargeBeginTime: "开始充电时间",
        chargeEndTime: "结束充电时间",
        payTime: "支付时间",
        chargeDuration: "充电时长",
        delayDuration: "占桩时长",
        chargeElect: "电量(kWh)",
        chargeAmount: "电费(元)",
        serviceAmount: "服务费(元)",
        time: "时间段",
        delayAmount: "占桩费(元)",
        totalAmount: "消费总金额(元)",
        discountAmount: "总金额优惠(元)",
        transactionAmount: "实付金额(元)",
        startSoc: "开始soc",
        endSoc: "结束soc",
        stopReason: "停止原因",
        orderSource: "订单来源",
        abnormalType: "是否异常",
        elecPrice: "电费费率(元/kWh)",
        servicePrice: "服务费率(元/kWh)",
        slotFlag: "电价类型",
        slotElecPrice: "电价(元)",
        delayMins: "时长(分钟)",
        delayFreeMins: "免费时长(分钟)",
        delayFree: "免费时长",
        sex: "性别",
        vipType: "会员类型",
        vin: "VIN码",
        cardType: "车型",
        staType: "站点类型",
        staStatus: "站点状态",
        staAddr: "充电站地址",
        gunPkId: "枪编号",
        manufacturer: "归属厂商",
        deviceType: "电桩类型",
        devicemodel: "设备型号",
        ratedPower: "额定功率",
        ratedCurrent: "额定电流",
        ratedVoltage: "额定电压",
        timeInterval: "时段",
        chargeDiscount: "电费优惠",
        serviceDiscount: "服务费优惠",
        delayDiscount: "占桩费优惠",
        totalDiscount: "优惠总金额",
        chargeTransAmount: "实付电费(元)",
        serviceTransAmount: "实付服务费(元)",
        jian: "尖",
        feng: "峰",
        ping: "平",
        gu: "谷",
        beforeBalance: "消费前金额(元)",
        afterBalance: "消费后金额(元)",
        reteInfo: "电桩费率信息",
        charge: "充电次数(次)",
        startTime: "开始时间",
        endTime: "结束时间",
        modifyTime: "更新时间",
        staPkId: "站点编号",
        entUserName: "企业名称",
        chargingCard: "用户卡号",
        chargingMode: "充电方式",
        userType: "用户类型",
        consumptionPattern: "充电模式",
        startMode: "启动方式",
        vipLevel: "会员等级",
    },
    // 订单列表页面
    orderList: {
        orderSource1: "线上订单",
        orderSource2: "线下订单",
        exportType: "默认",
        exportType2: "详情",
        end: "已结束充电",
        endConfirm: "确定要结束该订单吗?",
        endLoadingTips: "下发停止充电命令",
        endLoadingTips2: "系统将给充电桩下达停止充电命令，若15s内订单状态无法变更为“充电完成”，将继续进行第2步操作",
        endLoadingTips3: "生成平台充电报告",
        endLoadingTips4: "系统将给充电桩推送平台充电报告，若15s内订单状态无法变更为“充电完成”，将继续进行第3步操作",
        endLoadingTips5: "修改订单状态为异常单",
        endLoadingTips6: "系统将修改此订单为异常单，用户可正常进行下一次的充电操作",
        endLoading: "处理中..",
        endCharge: "结束充电",
        loadingSuccess: "下发停止命令成功",
        success: "生成平台报告成功",
        orderError: "订单状态已变更为异常",
        endSuccess: "结束成功",
        pageTitle: "充电订单",
        totalChargeElect: "总充电量(kWh)",
        totalTransactionAmount: "实际总收入(元)",
        totalServiceAmount: "服务费(元)",
        totalChargeAmount: "电费(元)",
        totalDelayAmount: "占桩费(元)",
        totalDiscount: "总金额优惠(元)",
        totalServiceDiscount: "服务费优惠(元)",
        totalChargeDiscount: "电费优惠(元)",
    },
    // 订单异常结算页面
    abnormalOrder: {
        pileCharging: "桩计费",
        chargeTime: "充电时段",
        stopReason: "停止原因",
        pileChargeAmount: "桩充电费总额（元）",
        sysCharging: "平台计费",
        sysChargeAmount: "平台充电费总额（元）",
        pileErrorValue: "与桩误差值：",
        normalErrorValue: "正常误差值：差值小于0.5元或差值比例小于20%",
        usePileCharging: "使用桩计费",
        useSysCharging: "使用平台计费",
        countType: "计算公式：桩充电费总额/平台充电费总额+占桩费总额",
        payAmount: "支付总额",
    },
    //订单详情
    orderDetails: {
        aorderDetailsTitle: "充电订单详情",
        userSiteTabTitle: "用户及站点信息",
        chargeType: "充电类型",
        chargeStatus: "充电状态",
        chargingModel: "充电策略",
        chargeElect: "充电电量",
        chargeDuration: "充电时长",
        orderCheckDetails: "订单校验详情",
        chargeDataEchart: "充电数据",
        chargeMoneyEchart: "充电计费数据曲线",
        batteryEchart: "电池信息曲线",
        pileSignal: "桩信号强度",
        faultCode: "异常编码",
        faultName: "异常名称",
        faultDesc: "异常描述",
        userInfo: "用户信息",
        siteInfo: "站点信息",
        siteId: "站点ID",
        pileInfo: "桩信息",
        rateInfo: "费用信息",
        errorHandle: "异常处理",
        billingMethod: "计费方式",
        operationTime: "操作时间",
        operationoOject: "操作对象",
        pileCreationTime: "桩投运时间",
        chargeFeeYLeftName: "费用(元)",
        chargeFeeYRightName: "电量(kW/h)",
        chargeYLeftName: "电压(V)/电流(A)/功率(kW)",
        chargeTemperatureYLeftName: "温度",
        chargeTemperatureYRightName: "电压",
        // 详情几个图表
        insertGun: "插枪",
        startCharging: "启动充电",
        endCharging: "结束充电",
        draw: "拔枪",
        outputVoltage: "输出电压",
        chargingPower: "充电功率",
        outputCurrent: "输出电流",
        demandVoltage: "需求电压",
        demandCurrent: "需求电流",
        cpVoltage: "CP电压",
        chargerTemperature: "充电机温度",
        gunTemperature: "枪口温度",
        brmProtocol: "brm协议版本",
        brmBatteryType: "brm电池类型",
        brmBatteryCapacity: "brm电池额定容量",
        brmRatedVoltage: "brm额定总电压",
        BCPMaxVoltage: "BCP单体最高电压",
        BCPMaxCurrent: "BCP最高电流",
        BCPBatteryEnergy: "BCP电池总能量",
        BCPMacVoltage: "BCP最高充电电压",
        BCPMaxTemperature: "BCP最高温度",
        BCPStartSOC: "BCP开始SOC",
        BSMMaxTemperature: "BSM最高动力电池温度",
        BCSMaxBatteryVoltage: "BCS最高单体电池电压",
        // 结算信息
        settlementTableName: "项目",
        settlementTablePayableAmount: "应付(元)",
        settlementTableDiscountAmount: "优惠(元)",
        settlementTabletransAmount: "实付(元)",
        settlementTabletransDl: "电费",
        settlementTabletransServer: "服务费",
        settlementTabletransDelay: "占桩费",
        retaInfoTab1: "结算信息",
        retaInfoTab2: "充电费用信息",
        retaInfoTab3: "占桩费用信息",
        retaInfoTab4: "VIP会员/优惠券优惠信息",
        total: "合计",
        vipDiscount: "VIP会员优惠",
        couponDiscount: "优惠券优惠",
        serviceAmount: "应付服务费（元）",
        serviceDiscount: "优惠服务费（元）",
        vipDiscountAmount: "VIP优惠",
        couponDiscountAmount: "优惠券",
        serviceTransAmount: "实付服务费（元）",
        chargeAmount: "应付电费（元）",
        chargeDiscount: "优惠电费（元）",
        chargeTransAmount: "实付电费（元）",
        delayAmount: "应付占桩费（元）",
        delayDiscount: "优惠占桩费（元）",
        delayTransAmount: "实付占桩费（元）",
        totalAmount: "应付合计（元）",
        totalDiscount: "总金额优惠（元）",
        transactionAmount: "实付合计（元）",
        discountTotal: "优惠合计（元）",
        discountName1: "活动",
        discountName2: "企业",
        discountName3: "接口用户",
        discountName4: "互联互通",
        discountName5: "非实名卡",
        typeName1: "活动",
        typeName2: "企业",
        typeName3: "接口用户",
        typeName4: "互联互通",
        typeName5: "非实名卡",
        //费率表格
        dlInfo: "用电信息",
        slotFlagDesc: "用电类型",
        time: "用电时段",
        electricity: "电量（kWh）",
        standardExpenses: "标准费用",
        slotServicePrice: "服务费率(元/kWh)",
        slotElecPrice: "电费费率(元/kWh)",
        discountServiceAmount: "服务费优惠(元)",
        discountElectAmount: "电费优惠(元)",
        cost: "活动/企业/互联互通/接口用户费用",
        delayCost: "企业/互联互通/接口用户费用",
        delayInfo: "占桩信息",
        minutesOhter: "占桩时长（分钟）",
        slotDelayPrice: "费率(元/分钟)",
        delayFee: "应付占桩费(元/分钟)",
        discountAmountOhter: "占桩费优惠（元）",
        discountType: "优惠类型",
        vipTotalDiscount: "合计优惠",
        discount: "优惠",
    },
    // 离线卡订单
    offCardOrder: {
        cardPhysicalSn: "流水号",
        cardSn: "物理卡号",
        chargeMode: "充电方式",
        dealType: "订单状态",
        exportName: "离线卡订单",
        dl: "充电电量(度)",
        amount: "收入金额(元)",
        service: "服务费(元)",
        chargingTime: "充电时长",
        orderNumber: "订单数量(笔)",
        offCardNum: "离线卡数量(个)",
        chargingType: "充电方式",
    },
    // 离线卡详情
    offCardOrderDetails: {
        pageTitle: "充电订单详情",
    },
    //运营数据
    operationData: {
        revenueTitle: "营收统计",
        revenueTime: "统计支付时间",
        totalTransAmount: "总收入统计(元)",
        totalTransServiceAmount: "服务费(元)",
        totalTransElecAmount: "电费(元)",
        totalTransDelayAmount: "占桩费(元)",
        proportion: "占总收入",
        settlementInfo: "结算信息",
        unsettledOrderNum: "未结算日结单数(笔)",
        notPaidDrawCashOrderNum: "未付款提现单数(笔)",
        undrawAmount: "未提现金额(元)",
        inPayAmount: "正在提现金额(元)",
        drawedAmount: "已提现金额(元)",
        serviceCharges: "累计提现手续费(元)",
        orderTitle: "订单统计",
        chargeOrderCount: "充电订单量(笔)",
        reservationOrderCount: "预约订单量(笔)",
        offlineOrderCount: "离线卡订单量(笔)",
    },
    //事件告警
    alarmEvent: {
        alarmTime: "告警时间",
        eventAmount: "事件总数",
        todayEvent: "今日事件",
        alarmRatio: "告警比例",
        alarmLevel: "告警级别",
        alarmType: "告警类型",
        equipmentAlarmAmountTop5: "设备故障告警次数TOP5",
        stationAlarmAmountTop5: "站点告警次数TOP5",
        equipmentSn: "设备sn",
        stationName: "站点名称",
        quantity: "次数",
        faultDesc: "事件描述",
        recoverTime: "恢复时间",
        duration: "异常时长",
        alarmStatus: "当前状态",
        equipmentType: "设备类型",
    },
    //站点监控
    siteMonitor: {
        province: "省",
        city: "市",
        type: "类型",
        power: "功率",
        equipmentAmount: "设备数量(个)",
        gun: "枪",
        number: "编号",
        voltage: "电压",
        current: "电流",
        chargeElect: "充电电量",
        totalPower: "累计充电量",
        thisPower: "当前输出功率",
        setPower: "设置输出功率",
        totalTimes: "累计充电次数(次)",
        totalHours: "累计充电时长",
        accountPkId: "充电账号",
        accountType: "账户类型",
        carVin: "车辆VIN码",
        chargedMinutes: "充电时长",
        chargingPower: "充电量",
        predictAmount: "充电金额",
        faultInfo: "故障信息",
        orderDetails: "订单详情",
    },
    //站点信息
    pileInfo: {
        operationType: "营业类型",
        staStatus: "运营状态",
        pileList: "桩列表",
    },
    // 站点详情
    pileInfoDetail: {
        city: "城市",
        staAddress: "地址",
        position: "建设场所",
        staLat: "经纬度",
        staTypeName: "站点类型",
        fullName: "关联商户",
        tagInfoVos: "站点标签",
        commissioningDate: "投运时间",
        businessBeginHours: "开放时间",
        parkNum: "车位数量",
        serviceTel: "服务电话",
        phoneNo: "站点电话",
        hasFreePark: "免费停车",
        yes: "是",
        no: "否",
        remarks: "温馨提示",
        feeName: "站点费率",
        DC: "直流桩",
        AC: "交流桩",
        oprDelayFeeInfos: "占桩费",
        delayFreeMinutes: "免费时长",
        staPics: "站点图片",
        staInfo: "充电桩信息",
        totalDev: "总设备",
        dcGunCount: "直流枪口",
        acGunCount: "交流枪口",
        tab1: "站点详情",
        tab2: "维护/费率变更记录",
        price: "总价(元/kWh)",
        manufacturerName: "设备商",
        ratedPower: "额定功率(kW)",
        delayUnit: "元/分",
        reason: "原因",
        debuggingPeople: "调试人员",
        debuggingContent: "调试内容",
        oldFeeName: "旧费率",
        newFeeName: "新费率模版",
        replaceTime: "更换日期",
    },
    // 站点电价列表
    pileInfoEle: {
        addRateBtn: "增加费率模板",
        upRateBtn: "更换费率模板",
        delRateBtn: "删除费率模板",
        rateTpl: "费率模板",
        feeName: "模板名称",
        feeNamePl: "请输入模板名称",
        acRate: "交流桩费率",
        dcRate: "直流桩费率",
        delayRate: "占桩费率",
        delayFreeMinutes: "免费时长(分钟)",
        rate: "费率",
        elePriceList: "电价列表",
        slotFlag: "电价类型",
        slotElecPrice: "电价(元)",
        slotServicePrice: "服务费(元/kWh)",
        time: "时间段",
        slotDelayPrice: "费率（元/分钟）",
        delRateConfirm: "确认删除当前电价吗",
        ratePl: "请选择费率",
    },
    // 充电桩信息
    pileList: {
        batchStaBtn: "批量关联/解绑",
        batchLineBtn: "批量上线/下线",
        addBtn: "增加桩信息",
        deviceStatus: "充电桩状态",
        showQcode: "二维码",
        editGun: "编辑枪",
        showUnlock: "解锁",
        offLine: "离线",
        showFee: "下发电价",
        outPile: "迁出充电桩",
        unbind: "解绑",
        downQCode: "下发",
        staName: "所属站点",
        internalNumber: "站内编号",
        chargeGunInfoVoList: "电枪型号",
        parkNo: "车位号",
        gunStatus: "电枪状态",
        editPile: "编辑桩",
        issueSuccess: "下发二维码成功",
        showFeeConfirm: "确定下发电价吗?",
        showFeeSuccess: "下发电价成功",
        showUnlockConfirm: "确定解锁吗?",
        showUnlockSuccess: "解锁成功",
        unbindSuccess: "解绑站点成功!",
        moveInSta: "迁入的充电站",
        moveInStaPl: "请选择充电站",
        remarks: "备注",
        gunOperation: "枪操作",
        updataRecord: "修改记录",
    },
    // 新增桩
    addPile: {
        // deviceType: "Equipment type",
        // deviceModelPkId: "Equipment model",
        // protocolPkId: "Agreement",
        // remark: "Remark",
        // gunInfo: "Muzzle information",
        // info: "Information",
        // addName: "Add charging pile",
        // staNamePl: "Site must be selected",
        // deviceTypePl: "Device type must be selected",
        // deviceModelPkIdPl: "Equipment model must be selected",
        // sn: "Pile number",
        // snPl: "The pile number cannot be empty",
        // snPl2: "Pile number must be a number",
        // snPl3: "Pile number must be numbers or letters",
        // pileNamePl: "Pile name cannot be empty",
        // deviceStatusPl: "Operation status cannot be empty",
        // protocolPkIdPl: "Please select agreement primary key",
        // qrcode: "QR code",
        // detailsName: "Charging point details",
        // updataName: "Modify charging point",
        // charging: "Charging",
        // inserted: "Gun inserted",
        // fault: "Fault",
        // disable: "Disable",
        // offLine: "off-line",
        // free: "Free",
        // full: "Full",
        // subscribe: "make an appointment",
        // offline: "Offline",
        // online: "Online",
        deviceType: "设备类型",
        deviceModelPkId: "设备型号",
        protocolPkId: "协议",
        remark: "备注",
        gunInfo: "枪口信息",
        info: "信息",
        addName: "新增充电桩",
        staNamePl: "所属站点必须选择",
        deviceTypePl: "设备类型必须选择",
        deviceModelPkIdPl: "设备型号必须选择",
        sn: "桩编号",
        snPl: "桩编号不能为空",
        snPl2: "桩编号必须为数字",
        snPl3: "桩编号必须为数字或者字母",
        pileNamePl: "桩名称不能为空",
        deviceStatusPl: "运营状态不能为空",
        protocolPkIdPl: "请选择协议主键",
        qrcode: "二维码",
        detailsName: "充电桩详情",
        updataName: "修改充电桩",
        charging: "充电中",
        inserted: "已插枪",
        fault: "故障",
        disable: "禁用",
        offLine: "离线",
        free: "空闲",
        full: "已充满",
        subscribe: "预约",
        offline: "下线",
        online: "上线",
        pileCommissioningDate: "投运时间",
        pileCommissioningDatePl: "请选择投运时间",
    },
    //分成结算
    splitSettlement: {
        shareSettlement: "分成结算",
        orderBreakdown: "订单分成明细",
        merchantName: "商户名称",
        chargingOrderNumber: "充电订单号",
        selectionTime: "选择时间",
        chargingStation: "充电站",
        chargeVolume: "充电量(kWh)",
        electricityBill: "电费(元)",
        serviceCharge: "服务费(元)",
        chargeableAmount: "应付充电金额(元)",
        discountAmount: "优惠金额(元)",
        totalAmountActuallyPaid: "实付总金额(元)",
        partitionMethod: "分成方式",
        merchantIncome: "商户收入(元)",
        operatorShare: "运营商分成(元)",
        orderDate: "订单日期",
        orderTimeError: "订单时间不能为空，请选择",
        errorStartTimeEndTime: "开始时间不能大于结束时间",
        contentConfirm: "确认要同意选中的数据吗？？",
        successfulOperation: "操作成功",
        daySettlementOrderNumber: "日结订单号",
        dailyStatementStatus: "日结单状态",
        settlementDate: "结算日期",
        numberOfOrders: "订单笔数",
        actualChargeAmount: "实付充电金额(元)",
        merchantIncomeAmount: "商户收入金额(元)",
        operatorShareAmount: "运营商分成金额(元)",
        createTime: "生成日期",
        pleaseSelectTheGenerationDate: "请选择生成日期",
        createTimeError: "生成日期开始时间不能大于结束时间",
        selectMonth: "请选择月结月份",
        confirmDate: "确认要确认选中的数据吗？",
        confirmGeneration: "确认重新生成吗？",
        withdrawnDate: "确认要撤回选中的数据吗？",
        selectDate: "确认要操作选中的数据吗？",
        selectDateToOperate: "请选择要操作的数据",
        deleteTitle: "作废原因",
        remarkPl: "请输入原因",
        supplement: "补单",
        orderNo: "选择日结订单号",
        orderNoPl: "请选择订单",
        staName: "充电站",
        settlementStatus: "核算状态",
        regenerate: "重新生成",
        allSettlement: "批量核算",
        settlement: "核算",
        errorInfo: "异常信息",
        accountingRecords: "核算记录",
        accountingRecordsStatus: "核算状态",
        accountingRecordsRepairStatus: "修复状态",
        accountingRecordsTime: "结算日期",
        initialAccounting: "初次核算",
        newAccounting: "最新核算",
        ComparisonResults: "对比结果差额",
        voidPl: "请选择要作废结算单",
        voidSuccess: "结算单作废成功",
        auditOrderPl: "请选择要审核结算单",
        auditOrder: "审核结算单",
        auditOrderSuccess: "结算单审核成功",
        auditOrderConfirm: "审核后不能撤销，请谨慎操作",
    },
    //商户提现
    withdrawal: {
        dataTitle1: "待提现(元)",
        dataTitle2: "已提现(元)",
        withdrawOrderStatus: "提现单状态",
        createTime: "生成日期",
        reviewDate: "审核日期",
        withdrawOrderTemplate: "提现单模板",
        withdrawOrderNumber: "提现单号",
        withdrawalAmount: "提现金额",
        transferFee: "手续费",
        actualWithdrawalAmount: "实际提现金额",
        withdrawalAdd: "新增提现单",
        preview: "预览",
        resubmit: "重新提交",
        withdraw: "撤回",
        annex: "附件",
        transferAmount: "实提现金额",
        completeTime: "完成提现日期",
        orderStatusDesc: "提现单状态",
        withdrawWithdrawal: "撤回提现单",
        withdrawWithdrawalConfirm: "确定撤回提现单?",
        withdrawWithdrawalSuccess: "撤回提现单成功",
    },
    // 提现单模板
    withdrawalTemplate: {
        orderNo: "提现订单号",
        order: "提现单",
        payee: "收款方",
        payer: "付款方",
        remarks: "备注",
        remarks1: "1、充电金额为用户通过运营商公众号在商户所辖充电站充电产生的金额；",
        remarks2: "2、实提现金额=本期提现金额 - 转账手续费；",
        remarks3: "3、转账手续费为线下转账费用；",
        cashExplain: "提现说明",
        cashExplain1: "1、账单核对无误后，申请提现方盖章确认后邮寄至付款方公司，或者通过电子邮件方式。付款方会在收到后3-5个工作日内完成线下对公或对私转账。",
        cashExplain2: "2、签字盖章后，即代表认同本次提现结算。",
        cashMch: "提现商户（盖章）：",
        sign: "授权代表签字：",
        time: "日期：",
        download: "下载证书",
        cashInfo: "提现信息",
        merchantName: "提现商户",
        staNameList: "所属充电站",
        previousBalance: "上期提现后余额",
        totalAmount: "本期提现金额",
        serviceCharges: "转账手续费",
        transferAmount: "实际现金额",
        collectionInfo: "收款信息",
        mchContactPerson: "商户联系人",
        mchPhoneNumber: "商户电话",
        bankAccountName: "公司名称",
        collectionAcc: "收款账户",
        bankDeposit: "开户银行",
        bankAccountNo: "收款账号",
        payerInfo: "付款方信息",
        oprName: "付款方名称",
        contacts: "联系人",
        telephone: "联系电话",
        invoiceType: "发票类型",
        openInfo: "开票信息",
        companyName: "公司名称",
        taxId: "税号",
        payerBankAccountNo: "账号",
        registerAddress: "收件地址",
        no: "无",
    },
    // 新增提现单
    withdrawFormAdd: {
        pageAdd: "新增提现单",
        pageUpdata: "重新提交提现单",
        invoiceType: "是否发票",
        totalAmount: "提现金额",
        availableAmount: "可提现金额",
        allWithdraw: "全部提现",
        minWithdraw: "最低提现金额",
        serviceCharges: "转账手续费",
        transferAmount: "实提现金额",
        collectionInfo: "收款信息",
        bankAccountName: "账户名称",
        bankDeposit: "开户银行",
        bankAccountNo: "银行账号",
        amountNullPl: "请输入提现金额",
        amountErrorPl: "提现金额必须大于0且小数位不超过两位",
        amountMin: "一次性提现金额不能少于",
        amountMax: "提现金额不能超过可提现金额",
    },
    // 头部
    header: {
        out: "退出登录",
        outConfirm: "确定要退出登录吗？",
        order: "待处理异常订单",
        goClick: "点击跳转",
        unit: "条",
        outTime: "登录过期，请重新登录",
    },
    //权限配置
    accessConfiguration: {
        roleName: "角色名称",
        remark: "备注",
        createUserId: "创建人",
        createTime: "创建时间",
        updateTime: "更新时间",
        menuModule: "菜单模块",
        menuGlance: "菜单一览",
        roleType: "角色类型",
        roleNameMsg: "请输入角色名称",
        roleNameErrorMsg: "角色名称不能多于20个字符",
        roleTypeMsg: "请选择角色类型",
        jurisdiction: "权限",
        operate: "操作日志",
        operationUserName: "最后一次操作人",
        operationTime: "最后一次操作时间",
        operationIp: "最后一次操作IP",
    },
    //用户管理
    userManage: {
        userName: "用户名",
        role: "所属角色",
        effectiveTime: "有效时间",
        status: "状态",
        password: "密码",
        confirmPassword: "确认密码",
        name: "姓名",
        addUser: "新增用户",
        updateUser: "修改用户",
        detailsUser: "用户详情",
        userNameMsg: "登录账号不能为空",
        roleMsg: "所属角色不能为空",
        passwordMsg: "密码不能为空",
        passwordLenMsg: "请输入6~18字符的密码",
        passwordValMsg: "密码不能包含空格、制表符、换行符",
        confirmPasswordMsg: "确认密码不能为空",
        confirmPasswordOldMsg: "确认密码与密码不一致",
        effectiveTimeStartMsg: "有效时间的开始时间必须填写",
        effectiveTimeStartValMsg: "开始时间不能大于结束时间",
        effectiveTimeEndMsg: "有效时间的结束时间必须填写",
        effectiveTimeEndValMsg: "结束时间不能小于开始时间",
        assignedSite: "已分配站点",
        unassignedSite: "未分配站点",
        moveLeft: "左移",
        moveRight: "右移",
        chargeStationName: "站点名称",
        resetPassword: "重置密码",
        fullName: "姓名",
        operationUserName: "操作人",
        operationTime: "操作时间",
        operationIp: "操作IP",
        operationTypeName: "操作类型",
        content: "操作内容",
    },
    //发票管理
    invoiceInfo: {
        applicationTime: "申请时间",
        globalSearch: "订单号/手机号",
        invoiceType: "发票类型",
        invoicingStatus: "开票状态",
        auditSettings: "审核设置",
        invoiceOrderNumber: "发票订单号",
        invoiceHeaderType: "抬头类型",
        invoiceTitle: "发票抬头",
        taxNumber: "税号",
        invoiceAmount: "开票金额",
        phoneNumber: "手机号",
        invoicing: "开票",
        invoiceUserName: "开票用户",
        issuer: "开票人",
        processingMethod: "处理方式",
        courierCompany: "快递公司",
        shipmentNumber: "物流单号",
        remark: "备注",
        haveBeenMailed: "邮寄",
        noNeedToMail: "无需邮寄",
        enterIssuer: "请输入开票人",
        selectMethod: "请选择开票方式",
        validationError: "表单验证错误",
        selectAddress: "请输入邮寄地址",
        enterNumber: "请输入邮寄订单号",
        orderNumberLength: "邮寄订单号长度不得小于八位",
        invoiceSuccessful: "开票成功",
        numberOfInvoices: "已开票数量（张）",
        electronicInvoice: "电子发票",
        paperInvoice: "纸质发票",
        totalInvoicedAmount: "已开票总金额（元）",
        invoicedServiceFee: "已开票服务费（元）",
        invoicedElectricityBill: "已开票电费（元）",
        invoiceReviewProcess: "发票审核流程",
        on: "开启",
        close: "关闭",
        selectionProcess: "请选择发票审核流程",
        setSuccessfully: "设置成功",
        invoiceInformation: "发票信息",
        serviceCharge: "服务费",
        electricityBill: "电费",
        eMail: "电子邮箱",
        receivingInformation: "接收信息",
        invoicingInformation: "开票信息",
        processingTime: "处理时间",
        invoiceSerialNumber: "发票流水号",
        payee: "收款人",
        reviewer: "复核人",
        unit: "单位",
        invoicePicture: "发票图片",
        shippingAddress: "收件地址",
        denialReason: "请输入拒绝原因",
        orderNumber: "订单号",
        delayFee: "占桩费（元）",
        discountedPrice: "优惠金额（元）",
        amountActuallyPaid: "实付金额（元）",
        reviewCompleted: "审核完毕",
        invoiceOperator: "发票运营商",
        invoiceOrder: "发票订单",
        invoiceAuditRecord: "审核记录",
        operationTime: "操作时间",
        operationStatus: "处理动作",
        operation: "处理人",
        applyStatuse: "当前状态",
        confirmAudit: "确定要审核通过吗?",
        operationSys: "系统自动处理",
        registerAddress: "注册地址",
        registerTelephone: "注册电话",
        bankDeposit: "开户银行",
        bankAccountNo: "银行账户",
        invoiceSettings: "发票设置",
        hasOpenAudit: "是否开启发票审核",
        invoiceTypePl: "请选择发票类型",
        hasOpenAuditPl: "请选择是否开启",
    },
    // 预约订单
    reserveChargingOrder: {
        durationRange: "预约时长",
        stopReason: "结束原因",
        startTime: "预约开始时间",
        handle: "申诉处理",
        reservationOrderNo: "预约单号",
        chargingTime: "预约充电时间",
        frozenAmount: "冻结金额(元)",
        stopTime: "预约结束时间",
        actualDuration: "实际预约时长",
        transactionAmount: "实付金额(元)",
        reasonType: "申诉原因",
        picture: "现场照片",
        auditResult: "处理结果",
        auditMind: "处理意见",
        reasonTitle: "预约单申诉处理",
        auditMindPl: "请输入处理意见",
        auditResultPl: "请选择处理结果",
        totalOrder: "预约单总数（笔）",
        confirm: "同意用户申诉后，充电预约冻结金额或已付金额将全额返还至用户账户，是否继续？",
        reserveOrderStatus: "预约单状态",
        reserveOrderTimeType: "各时长预约单数(笔)",
    },
    // 预约订单详情
    reserveChargingOrderOrder: {
        info: "预约订单信息",
        timingType1: "分钟",
        timingType2: "半小时",
        timingType: "收费类型",
        freeMinutes: "免费时长(分钟)",
        timeoutDuration: "运营商可容忍超时时长(分钟)",
        total: "费用(元)：",
        rate: "费率",
        slotFlag: "时段类型",
        time: "时间段",
        duration: "时长(分钟)",
        feeInfo: "计费信息",
        orderInfo: "订单信息",
        orderStatus: "订单状态",
        chargingOrderNo: "充电订单号",
        life: "生命周期",
        operatingUserName: "操作人",
        occurTime: "操作时间",
        stopReason: "原因",
        imgList: "辅助材料",
        refOrderNo: "退款订单号",
    },
    //子菜单标题
    childMenuTitle: {
        offCardOrderDetails: "离线卡订单详情",
        reserveChargingOrderDetails: "预约订单详情",
        chargeOrderDetail: "订单详情",
        errorOrderDetail: "异常详情",
        abnormalOrder: "异常处理",
        abnormalErrorOrder: "异常处理 ",
        // 发票管理
        invoiceDetails: "发票详情",
        invoiceAudit: "发票审核",
        permissionMune: "权限配置",
        siteMonitorDetails: "监控详情",
        // 桩
        pileUpdata: "充电桩修改",
        pileUpdataRecord: "桩修改记录",
    },
    delayFeeManage: {
        acRate: "交流桩占桩费率",
        dcRate: "直流桩占桩费率",
        acRateDetails: "交流占桩费详情",
        dcRateDetails: "直流占桩费详情",
        dcDelayFeeUpperLimit: "直流占桩费上限",
        acDelayFeeUpperLimit: "交流占桩费上限",
        delayFeeUpperLimit: "占桩费上限",
    },
    chargeFeeManage: {
        acRateDetails: "交流桩费率",
        dcRateDetails: "直流桩费率",
    },
    //运营分析
    operateAnalysis: {
        chargeData: "充电数据",
        echartData: "数据图表",
        totalChargePower: "充电量",
        totalElecAmount: "电费",
        totalServiceAmount: "服务费",
        totalChargeTimes: "充电次数",
        echartRadioCharge: "充电量/充电次数",
        echartRadioFee: "电费/服务费",
    },
    // 收入分析
    revenueAnalysis: {
        revenueTitle: "收支总额",
        totalIncomeAmount: "实收总金额",
        mchPayAmount: "支出总金额",
        oprTotal: "运营商分成",
        serviceCharges: "手续费",
        mchIncomeAmount: "收益金额",
        picTitle: "费用占比",
        revenueEchartTitle: "金额趋势",
        feeYName: "费用(元)",
    },
    //充值管理
    memberRecharge: {
        rechargeOrderNum: "充值订单数量(笔)",
        rechargeAmount: "充值金额(元)",
        rechargeTimes: "充值次数(次)",
        memberName: "会员名称",
        cellphoneNumber: "手机号码",
        orderNumber: "商户订单号",
        rechargeMethod: "充值方式",
        operatorCode: "运营商代码",
        operatorName: "运营商名称",
        memberNo: "会员号",
        memberPhoneNumber: "会员手机号",
        merchantOrderNumber: "商户订单号",
        paymentOrderNumber: "支付订单号",
        rechargeTime: "充值时间",
        orderStatus: "订单状态",
        accountType: "账户类型",
        accountNum: "账户号",
        rechargeInfo: "充值信息",
        rechargeUserNum: "充值用户数(个)",
    },
    //退款记录
    refundRecords: {
        pageTitle: "退款记录",
        refundApplicationTime: "退款申请时间",
        refundOrderQuantity: "退款订单数量(笔)",
        refundAmount: "退款金额(元)",
        orderStatus: "订单状态",
        globalSearch: "订单号/账户号/手机号",
        accountType: "账户类型",
        refundMethod: "退款方式",
        pendingReview: "待审核",
        rejected: "已拒绝",
        returned: "已退回",
        paymentFailed: "支付失败",
        nonPaymentNumber: "未支付",
        passed: "已通过",
        orderNumber: "订单号",
        accountNumber: "账户号",
        accountName: "账号名称",
        phoneNumber: "手机号",
        amountOfRefundRequested: "申请退款金额(元)",
        successfulRefundAmount: "已支付退款金额(元)",
        uploadCertificate: "上传凭证",
        transferVoucher: "转账凭证",
        pleaseUploadAPicture: "请上传图片",
        successfulOperation: "操作成功",
        refundReview: "退款审核",
        refundReviewPl: "请选择退款审核方式",
        refundNoteText: "退款说明文字",
        refundNoteTextPl: "请输入退款说明文字",
        autoText: "退款权限",
        autoTextPl: "请选择退款权限方式",
        refundRecordDetails: "退款记录详情",
        applicationInformation: "申请信息",
        processingInformation: "处理信息",
        reviewInformation: "审核信息",
        refundOrderStatus: "退款订单状态",
        remark: "备注",
        refundDetails: "退款明细信息",
        refundFailed: "退款失败",
        refundSuccessfully: "退款成功",
        agreeToARefund: "同意退款",
        refusalToRefund: "拒绝退款",
        enterReason: "请输入拒绝退款理由",
        processingTime: "处理时间",
        processingAction: "处理动作",
        processResult: "处理结果",
        detailedOrderNumber: "明细订单号",
        amount: "金额",
        refundTime: "退款支付时间",
        result: "结果",
        refundToUser: "退款至用户",
        refundErrResult: "原因",
        allAudit: "批量审核",
        allAuditType: "审核类型",
        rejectRemark: "拒绝理由",
        auditUserName: "处理人",
        refundStatus: "当前状态",
        refundType: "退款类型",
        refundStatusName: "退款状态",
        noHandleData: "暂无处理信息",
        paidRefundAmount: "已支付退款金额",
    },
};
